const selectIncidentTable = (state) => state.incidentTable;
export default selectIncidentTable;
